import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
	providedIn: 'root',
})
export class ExternalLinkGuard {
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
		window.location.href = route?.data?.externalUrl;
		return true;
	}
}
